var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentsUnselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "documents_unselected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-/-icons-/-documents-(black)",
    transform: "translate(-2.000000, -1.000000)",
    fill: "#172134",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00004312,1.003 L8.00004312,1 L18.9980231,1 C19.5500231,1 20.0000234,1.454996 20.0000234,1.991996 L20.0000234,20.007986 C19.9998231,20.271186 19.8950231,20.523486 19.7088231,20.709486 C19.5226231,20.895486 19.2702231,20.999986 19.0070231,20.999986 L2.99304312,20.999986 C2.86172312,20.999086 2.73187312,20.972286 2.61089312,20.921186 C2.48991812,20.870086 2.38019312,20.795686 2.28798412,20.702186 C2.19577512,20.608686 2.12288712,20.497886 2.07348312,20.376186 C2.02407812,20.254586 1.99912512,20.124286 2.00002342,19.992986 L2.00002342,7 L8.00004312,1.003 Z M4.83004312,6.999996 L8.00004312,6.999996 L8.00004312,3.829996 L4.83004312,6.999996 Z M10.0000431,2.999996 L10.0000431,7.999996 C10.0000431,8.265216 9.89469312,8.519566 9.70715312,8.707106 C9.51962312,8.894646 9.26526312,8.999996 9.00004312,8.999996 L4.00004312,8.999996 L4.00004312,18.999996 L18.0000231,18.999996 L18.0000231,2.999996 L10.0000431,2.999996 Z",
    id: "documents_unselected"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsUnselected);
export default __webpack_public_path__ + "static/media/documents_unselected.134d1d87c3b5d79397337706e3d865ad.svg";
export { ForwardRef as ReactComponent };